/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaCheck, FaRegFilePdf } from 'react-icons/fa';

import { Text, RegularText } from '../../common/Text';
import StyledTappable from '../../common/StyledTappable';
import { openFileViewer } from '../../../actions';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  max-width: 80%;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0.25rem 0;
  overflow: hidden;
`;

const DoctorImage = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 1.5rem;
  margin-right: 0.375rem;
`;

const BubbleContainer = styled(StyledTappable)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: hidden;
  padding: 0.625rem 0.75rem;
  background: rgba(228, 220, 248, 0.2);
  border-radius: 0.875rem;
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FileIcon = styled(FaRegFilePdf)`
  width: 1rem;
  margin-right: 0.5rem;
`;

const FileName = styled(Text)`
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const TimestampContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1rem;
`;

const TickIcon = styled(FaCheck)`
  opacity: 0.5;
  font-size: ${() => `${0.625 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin-right: 0.25rem;
`;

const TimestampText = styled(RegularText)`
  opacity: 0.5;
  font-size: ${() => `${0.75 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const DoctorFileMessage = ({
  fileName,
  doctorImage,
  url,
  messageId,
  timestamp,
  sponsorId,
  authToken,
}) => {
  const dispatch = useDispatch();
  return (
    <OuterContainer>
      <DoctorImage src={doctorImage} />
      <BubbleContainer
        onTap={() => {
          dispatch(
            openFileViewer({
              contentUrl: url,
              title: 'FileViewer',
              type: 'pdf',
            })
          );
        }}
      >
        <MessageContainer>
          <FileIcon />
          <FileName>{fileName}</FileName>
        </MessageContainer>
        {timestamp && (
          <TimestampContainer>
            <TickIcon />
            <TimestampText>
              {new Date(timestamp).toLocaleTimeString('nu', {
                hour: 'numeric',
                minute: '2-digit',
              })}
            </TimestampText>
          </TimestampContainer>
        )}
      </BubbleContainer>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        id={messageId}
        style={{ display: 'none' }}
      />
    </OuterContainer>
  );
};

const mapStateToProps = (state) => ({
  sponsorId: state.user.sponsorId,
  authToken: state.user.authToken,
});

DoctorFileMessage.propTypes = {
  fileName: PropTypes.string,
  doctorImage: PropTypes.string,
  url: PropTypes.string,
  messageId: PropTypes.string,
  timestamp: PropTypes.number,
};

export default connect(mapStateToProps)(DoctorFileMessage);
